module.exports = __webpack_public_path__ + "img/37.f10baf30.png";